module.exports = __webpack_public_path__ + "media/customizations/woodforest/logo-f3b5a0a03342a22b9f8c9106f87e52b1.png";